// Central brand & logo configuration. Change logos here only.
export const BRAND = {
  name: "SHB Finans",
  subBrand: "Sağlam Hukuk Bürosu",
  logos: {
    symbol: "/logos/symbol_square.jpg",       // square symbol — login, app icon, favicon
    horizontal: "/logos/logo_horizontal.jpg", // horizontal — desktop sidebar / mobile header
    compact: "/logos/logo_compact.jpg",       // small horizontal — compact contexts
  },
};
